import { cva, type VariantProps } from "class-variance-authority";
import { clsx } from "clsx";

import type { JSX } from "react";

const iconAvatarVariants = cva(
  "flex shrink-0 items-center justify-center bg-black-100 text-black-950",
  {
    variants: {
      size: {
        xs: "size-6 rounded-lg [&_svg]:size-4",
        sm: "size-8 rounded-xl [&_svg]:size-4",
        md: "size-10 rounded-2xl [&_svg]:size-5",
        lg: "size-12 rounded-3xl [&_svg]:size-6",
      },
    },
    defaultVariants: {
      size: "md",
    },
  },
);

type IconAvatarProps = VariantProps<typeof iconAvatarVariants> & {
  children: JSX.Element;
  className?: string;
};

export default function IconAvatar({
  children,
  className = null,
  size,
}: IconAvatarProps) {
  return (
    <div
      className={clsx(
        iconAvatarVariants({
          size,
        }),
        className,
      )}
    >
      {children}
    </div>
  );
}
